import attachEnterAsClick from 'utils/attachEnterAsClick';
import $ from 'jquery';

const printSocialShareInit = () => {
    const $printBtn = $('.print-control');
    const $socialShare = $('.share-control');
    if (!$printBtn.length || !$socialShare.length) { return; }

    $printBtn.on('click', () => {
        window.print();
    });
    attachEnterAsClick($printBtn);

    $socialShare.each(function () {
        const $shareTrigger = $('.social-share-trigger', this);
        const $shareLinks = $(this).find('.share-links');

        $shareTrigger.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $socialShare.not(this).find('.share-links').removeClass('is-visible');
            $shareLinks.toggleClass('is-visible');
        });
        attachEnterAsClick($shareTrigger);

        // Close the share links on click of anywhere
        $(document).click(() => {
            $shareLinks.removeClass('is-visible');
        });

        // Accessibility feature, if the user tab off the share-link then the links hide
        $shareLinks.find('a').blur(() => {
            setTimeout(() => {
                if (!$shareLinks.find('a:focus').length) {
                    $shareLinks.removeClass('is-visible');
                }
            }, 500);
        });
    });
};

const copyLink = () => {
    const $els = $('.js-copy-link');

    if ($els.length === 0) return;

    $els.click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $el = $(this);

        const tempInputDom = document.createElement('input');
        document.body.appendChild(tempInputDom);
        tempInputDom.setAttribute('value', $el.attr('href'));
        tempInputDom.select();
        document.execCommand('copy');
        document.body.removeChild(tempInputDom);

        $el.trigger('showtooltip', this);
        setTimeout(() => {
            $el.trigger('hidetooltip', this);
        }, 1500);
    });
};

$(() => {
    printSocialShareInit();
    copyLink();
});
